import React from "react";
import Navbar from "../landing-page/LandingPageNavbar";
import image1 from "../../assets/images blog 36/images blog 36/image 1.png";
import image2 from "../../assets/images blog 36/images blog 36/image 2.png";
import image3 from "../../assets/images blog 36/images blog 36/image 3.png";

function Blog36() {
  return (
    <div className="bg-[#F9F9F9]">
      <Navbar />
      <div className="min-h-screen w-full flex justify-center">
        <div className="flex flex-col items-center w-[90%] sm:w-[80%] md:w-[80%] lg:w-[80%] xl:w-[60%] mt-10 px-3 sm:px-4 md:px-6 lg:px-6 py-4 sm:py-8 md:py-10 ">
          {/* <div className="w-full text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold mb-4">
           How We Blend Text + Graphics to Create Engaging Presentations
          </div>
          <div className="flex h-[60vh] w-full mb-6">
            <img
              src={image1}
              alt="Blog Cover"
              className="object-cover w-full h-full rounded"
            />
          </div> */}

          <div className="w-full flex-col justify-center items-start mb-4">
            <section className="w-full flex-col justify-center items-start mb-12">
              <h1 className="text-4xl font-extrabold leading-tight mb-4">
                Why Speed Matters: Saving Hours Every Week With AI Presentations
              </h1>

              {/* Image: The Race Against Time in Modern Workflows */}
              <div className="flex h-[60vh] w-full mb-6">
                <img
                  src={image1}
                  alt="THE RACE AGAINST TIME IN MODERN WORKFLOWS graphic"
                  className="object-cover w-full h-full rounded"
                />
              </div>

              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                Introduction: The Race Against Time in Modern Workflows
              </h2>

              <p className="w-full text-base leading-relaxed mb-4">
                Every professional today faces the same challenge —{" "}
                <span className="font-bold">
                  too much to communicate, not enough time to prepare
                </span>
                . Whether you're a marketer creating client decks, a consultant
                preparing reports, or a startup founder pitching to investors,
                presentations are an everyday necessity.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                But let's be honest — building{" "}
                <span className="font-bold">PowerPoint presentations</span> or{" "}
                <span className="font-bold">Google Slides decks</span> the
                traditional way is slow.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                You start with a blank template, shuffle through slides, adjust
                fonts, resize charts, and spend hours formatting — time that
                could be used for strategy, selling, or decision-making.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                That's why{" "}
                <span className="font-bold">AI-powered presentation tools</span>{" "}
                like <span className="font-bold">Zynth.ai</span> are changing
                the game. By automating design, structure, and brand
                consistency, AI transforms hours of manual work into minutes of
                intelligent creation.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                This blog explores why{" "}
                <span className="font-bold">
                  speed is the new productivity currency
                </span>{" "}
                — and how{" "}
                <span className="font-bold">AI presentation makers</span> like
                Zynth save hours every week for modern teams.
              </p>

              {/* Horizontal Rule/Divider (Approximation of the line in the image) */}
              <hr className="my-12 border-gray-200" />

              <h2 className="text-2xl font-bold leading-relaxed mb-6">
                Why Speed = Productivity in Modern Business
              </h2>

              <p className="w-full text-base leading-relaxed mb-4">
                In the fast-paced digital economy, speed isn't just convenience
                — it's competitive advantage.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                When teams can move faster, they can:
              </p>

              <ul className="space-y-3 mb-6 text-base leading-relaxed ml-6">
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>Pitch to clients before competitors do.</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>Deliver reports instantly after meetings.</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>Turn feedback into updates the same day.</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>Communicate insights while they're still fresh.</span>
                </li>
              </ul>

              <p className="w-full text-base leading-relaxed mb-4">
                AI-powered tools like{" "}
                <span className="font-bold">Zynth Platform</span> make this
                possible by automating the slowest parts of presentation
                creation — from structure to design.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                Speed no longer means cutting corners; it means{" "}
                <span className="font-bold">cutting waste</span>.
              </p>
            </section>
            {/* END of Screenshot 2025-11-21 180457.png Content */}

            <hr className="my-12 border-gray-200" />

            {/* START of Screenshot 2025-11-21 180527.png Content */}
            <section className="w-full flex-col justify-center items-start mb-12">
              <h1 className="text-4xl font-extrabold leading-tight mb-4">
                Enter Zynth: The AI Presentation Revolution
              </h1>

              <p className="w-full text-base leading-relaxed mb-4">
                The <span className="font-bold">Zynth Platform</span>, with its{" "}
                <span className="font-bold">Zynth API</span> and{" "}
                <span className="font-bold">Zynth Google Slides Extension</span>
                , is built to redefine how professionals and enterprises create
                PowerPoint presentations and Google Slides decks.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                Unlike generic online ppt makers, Zynth doesn't just assemble
                slides — it{" "}
                <span className="font-bold">understands your content</span>,
                builds logical narratives, and applies your brand identity
                automatically.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                With Zynth, you don't just build faster — you build smarter.
              </p>

              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                How Zynth Speeds Up Presentation Creation
              </h2>

              {/* Image: Screenshot of the Zynth Interface */}
              <div className="flex h-[60vh] w-full mb-6">
                <img
                  src={image2}
                  alt="Screenshot of Zynth's presentation builder interface"
                  className="object-cover w-full h-full rounded"
                />
              </div>

              <p className="w-full text-base leading-relaxed mb-4">
                Here's how the Zynth ecosystem saves hours every week across
                teams:
              </p>

              {/* Step 1 */}
              <h3 className="text-xl font-bold leading-relaxed mb-2 mt-4">
                Step 1: Input Your Content
              </h3>
              <p className="w-full text-base leading-relaxed mb-4">
                Paste notes, bullet points, or a rough outline. No formatting or
                design knowledge needed.
              </p>

              {/* Step 2 */}
              <h3 className="text-xl font-bold leading-relaxed mb-2 mt-4">
                Step 2: Choose Your Brand Style
              </h3>
              <p className="w-full text-base leading-relaxed mb-4">
                Upload your logo, select colors, or connect your website for
                automatic brand extraction. Zynth instantly applies your brand
                guidelines to every deck.
              </p>

              {/* Step 3 */}
              <h3 className="text-xl font-bold leading-relaxed mb-2 mt-4">
                Step 3: AI Builds the Deck
              </h3>
              <p className="w-full text-base leading-relaxed mb-4">
                The <span className="font-bold">ai powerpoint generator</span>{" "}
                creates slides in seconds — complete with layout, icons,
                visuals, and charts. You can even select creativity levels or
                tone (formal, persuasive, educational).
              </p>

              {/* Step 4 */}
              <h3 className="text-xl font-bold leading-relaxed mb-2 mt-4">
                Step 4: Edit, Refine, and Present
              </h3>
              <p className="w-full text-base leading-relaxed mb-2">
                Using the <span className="font-bold">Zynth Extension</span>{" "}
                inside google presentation software, you can:
              </p>
              <ul className="space-y-3 mb-6 text-base leading-relaxed ml-6">
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Use <span className="font-bold">Quick Generate</span> for
                    one-click decks.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Add <span className="font-bold">Slide Narratives</span> for
                    structured storytelling.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Build <span className="font-bold">Custom Slides</span> with
                    charts, tables, and images.
                  </span>
                </li>
              </ul>
              <p className="w-full text-base leading-relaxed mb-4">
                Everything happens within Google Slides — no downloads, no
                switching apps.
              </p>
            </section>
            {/* END of Screenshot 2025-11-21 180527.png Content */}

            <hr className="my-12 border-gray-200" />

            {/* START of Screenshot 2025-11-21 180545.png Content */}
            <section className="w-full flex-col justify-center items-start mb-12">
              <h1 className="text-4xl font-extrabold leading-tight mb-4">
                Why Teams Love Zynth's Speed
              </h1>

              {/* Feature A */}
              <h3 className="text-xl font-bold leading-relaxed mb-2 mt-4">
                a. Instant Decks From Text
              </h3>
              <p className="w-full text-base leading-relaxed mb-4">
                Zynth turns your written notes or summaries into
                ready-to-present slides instantly. Perfect for consultants,
                managers, and educators.
              </p>

              {/* Feature B */}
              <h3 className="text-xl font-bold leading-relaxed mb-2 mt-4">
                b. Branded by Default
              </h3>
              <p className="w-full text-base leading-relaxed mb-4">
                No need to reapply logos, colors, or fonts every time. Zynth's
                brand intelligence layer keeps every slide consistent.
              </p>

              {/* Feature C */}
              <h3 className="text-xl font-bold leading-relaxed mb-2 mt-4">
                c. Native Google Slides Integration
              </h3>
              <p className="w-full text-base leading-relaxed mb-4">
                With the <span className="font-bold">Zynth Extension</span>, you
                stay inside your workflow. Generate, edit, and collaborate
                without exporting or switching platforms.
              </p>

              {/* Horizontal Rule/Divider (Approximation of the line in the image) */}
              <hr className="my-12 border-gray-200" />

              {/* Feature D */}
              <h3 className="text-xl font-bold leading-relaxed mb-2 mt-4">
                d. Custom API Automations
              </h3>
              <p className="w-full text-base leading-relaxed mb-4">
                Enterprises can use the{" "}
                <span className="font-bold">Zynth API</span> to generate decks
                automatically from reports, CRM data, or analytics dashboards.
              </p>
              <p className="w-full text-base leading-relaxed mb-4">
                Speed meets scalability.
              </p>

              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                The Psychology of Speed: Why It Boosts Creativity
              </h2>

              <p className="w-full text-base leading-relaxed mb-4">
                When you remove the manual grind, you unlock creative potential.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                Professionals often spend{" "}
                <span className="font-bold">
                  80% of their time on formatting
                </span>{" "}
                and only <span className="font-bold">20% on storytelling</span>.
                AI flips that ratio — letting you focus on what actually
                matters: the message.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                With tools like{" "}
                <span className="font-bold">Zynth's AI presentation maker</span>
                , creativity becomes effortless:
              </p>

              <ul className="space-y-3 mb-6 text-base leading-relaxed ml-6">
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Experiment with{" "}
                    <span className="font-bold">multiple visual styles</span> in
                    seconds.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Instantly reframe content for different audiences.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Spend more time refining strategy, not resizing text boxes.
                  </span>
                </li>
              </ul>

              <p className="w-full text-base leading-relaxed mb-4">
                Speed doesn't just save time — it enhances{" "}
                <span className="font-bold">thinking quality</span>.
              </p>

              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                Speed at Scale: Zynth for Enterprises and Agencies
              </h2>

              <p className="w-full text-base leading-relaxed mb-4">
                For large organizations, speed isn't about one presentation —
                it's about{" "}
                <span className="font-bold">system-wide acceleration</span>.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                Here's how Zynth delivers speed at scale:
              </p>

              {/* Table from the Image Content */}
              <div className="w-full mb-6 overflow-x-auto">
                <table className="min-w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-3 text-left">
                        Use Case
                      </th>
                      <th className="border border-gray-300 p-3 text-left">
                        Traditional Time
                      </th>
                      <th className="border border-gray-300 p-3 text-left">
                        With Zynth
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Weekly Sales Reports
                      </td>
                      <td className="border border-gray-300 p-3">4 hours</td>
                      <td className="border border-gray-300 p-3">15 minutes</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Marketing Dashboards
                      </td>
                      <td className="border border-gray-300 p-3">6 hours</td>
                      <td className="border border-gray-300 p-3">30 minutes</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Product Launch Decks
                      </td>
                      <td className="border border-gray-300 p-3">8 hours</td>
                      <td className="border border-gray-300 p-3">45 minutes</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Client Pitches
                      </td>
                      <td className="border border-gray-300 p-3">10 hours</td>
                      <td className="border border-gray-300 p-3">1 hour</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="w-full text-base leading-relaxed mb-4">
                That's hundreds of hours saved monthly across departments.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                With the <span className="font-bold">Zynth API</span>, these
                processes can be automated entirely — generating fresh decks
                automatically every time new data is available.
              </p>
            </section>

            <section className="w-full flex-col justify-center items-start mb-12">
              <h1 className="text-4xl font-extrabold leading-tight mb-4">
                The Zynth Advantage: Built for Real Speed
              </h1>

              <p className="w-full text-base leading-relaxed mb-4">
                Most <span className="font-bold">ai powerpoint generators</span>{" "}
                and <span className="font-bold">online ppt makers</span> promise
                "fast design." But Zynth is designed for{" "}
                <span className="font-bold">end-to-end acceleration</span> —
                from idea to final delivery.
              </p>

              {/* Feature Comparison Table */}
              <div className="w-full mb-6 overflow-x-auto">
                <table className="min-w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-3 text-left">
                        Feature
                      </th>
                      <th className="border border-gray-300 p-3 text-left">
                        Zynth
                      </th>
                      <th className="border border-gray-300 p-3 text-left">
                        Generic Tools
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Google Slides Integration
                      </td>
                      <td className="border border-gray-300 p-3">Yes</td>
                      <td className="border border-gray-300 p-3">No</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Brand Automation
                      </td>
                      <td className="border border-gray-300 p-3">Full</td>
                      <td className="border border-gray-300 p-3">Partial</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-3">Custom API</td>
                      <td className="border border-gray-300 p-3">Yes</td>
                      <td className="border border-gray-300 p-3">No</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Multi-Slide Types (graphs, tables, points, timelines)
                      </td>
                      <td className="border border-gray-300 p-3">Yes</td>
                      <td className="border border-gray-300 p-3">Limited</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Real-Time Collaboration
                      </td>
                      <td className="border border-gray-300 p-3">Yes</td>
                      <td className="border border-gray-300 p-3">
                        Manual sharing
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 p-3">
                        Enterprise Security
                      </td>
                      <td className="border border-gray-300 p-3">Yes</td>
                      <td className="border border-gray-300 p-3">Limited</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="w-full text-base leading-relaxed mb-4">
                That's why agencies, SaaS teams, and large enterprises choose
                Zynth — it's not just a faster{" "}
                <span className="font-bold">slides maker</span>, it's a{" "}
                <span className="font-bold">smarter presentation system</span>.
              </p>

              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                Beyond Time-Saving: The ROI of Speed
              </h2>

              <p className="w-full text-base leading-relaxed mb-4">
                Let's quantify the impact.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                If a 10-person marketing team saves 5 hours per week using{" "}
                <span className="font-bold">Zynth</span>, that's:
              </p>

              <ul className="space-y-3 mb-6 text-base leading-relaxed ml-6">
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    <span className="font-bold">50 hours weekly</span>
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    <span className="font-bold">200 hours monthly</span>
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Over <span className="font-bold">2,400 hours a year</span> —
                    equal to 1.2 full-time employees saved.
                  </span>
                </li>
              </ul>

              <p className="w-full text-base leading-relaxed mb-4">
                And that's just the productivity ROI. Add the improved brand
                consistency and reduced design costs, and Zynth's impact
                compounds across operations.
              </p>
            </section>

            <hr className="my-12 border-gray-200" />

            {/* ====================================================================
    SECTION 2: Zynth for Real-Time Workflows (From image_e1ede9.png)
    ==================================================================== */}
            <section className="w-full flex-col justify-center items-start mb-12">
              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                Zynth for Real-Time Workflows
              </h2>

              {/* Image: The Zynth Extension and API in Action - Multi-screen display */}
              <div className="flex h-[40vh] w-full mb-6">
                <img
                  src={image3}
                  alt="Zynth Extension and API enabling real-time workflows"
                  className="object-cover w-full h-full rounded"
                />
              </div>

              <p className="w-full text-base leading-relaxed mb-4">
                The <span className="font-bold">Zynth Extension</span> and{" "}
                <span className="font-bold">Zynth API</span> allow teams to work
                as fast as their data updates.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                For example:
              </p>

              <ul className="space-y-3 mb-6 text-base leading-relaxed ml-6">
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <div>
                    <span className="font-bold">Sales teams:</span>{" "}
                    Auto-generate client proposals directly from CRM inputs.
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <div>
                    <span className="font-bold">Marketing:</span> Turn campaign
                    results into slides immediately after launch.
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <div>
                    <span className="font-bold">Finance:</span> Build monthly
                    reports directly from Google Sheets data.
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <div>
                    <span className="font-bold">Executives:</span> Get
                    auto-updated board decks every quarter.
                  </div>
                </li>
              </ul>

              <p className="w-full text-base leading-relaxed mb-4">
                Speed here doesn't just mean convenience — it means alignment,
                agility, and competitive readiness.
              </p>

              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                How Zynth's Speed Powers Innovation
              </h2>

              <p className="w-full text-base leading-relaxed mb-4">
                When teams no longer spend hours on slides, they have room for
                innovation:
              </p>

              <ul className="space-y-3 mb-6 text-base leading-relaxed ml-6">
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Agencies can scale creative output for multiple clients.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>Startups can focus on growth instead of design.</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">•</span>
                  <span>
                    Enterprises can align communication across global offices in
                    real time.
                  </span>
                </li>
              </ul>

              <p className="w-full text-base leading-relaxed mb-4">
                By removing friction,{" "}
                <span className="font-bold">Zynth's AI presentation maker</span>{" "}
                becomes a catalyst for innovation — where every idea turns into
                a visual story in minutes.
              </p>

              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                Getting Started: Your Fast-Track to AI-Generated Slides
              </h2>

              <p className="w-full text-base leading-relaxed mb-4">
                Want to see how fast Zynth really is? Here's your roadmap:
              </p>

              <ol className="space-y-3 mb-6 text-base leading-relaxed ml-6 list-decimal">
                <li>
                  <span>
                    Sign up on <span className="font-bold">Zynth.ai</span>.
                  </span>
                </li>
                <li>
                  <span>
                    Install the{" "}
                    <span className="font-bold">
                      Zynth Google Slides Extension
                    </span>{" "}
                    for direct integration.
                  </span>
                </li>
                <li>
                  <span>
                    Paste your text or upload your report — let Zynth generate
                    your deck.
                  </span>
                </li>
                <li>
                  <span>
                    Customize or refine slides instantly inside Google Slides.
                  </span>
                </li>
                <li>
                  <span>
                    Automate workflows using the{" "}
                    <span className="font-bold">Zynth API</span> for recurring
                    reports or dashboards.
                  </span>
                </li>
              </ol>

              <p className="w-full text-base leading-relaxed mb-4">
                In under 5 minutes, you'll see what "presentation speed" really
                feels like.
              </p>
            </section>

            <hr className="my-12 border-gray-200" />

            {/* ====================================================================
    SECTION 3: Conclusion (From image_e1ee25.png)
    ==================================================================== */}
            <section className="w-full flex-col justify-center items-start mb-12">
              <h2 className="text-2xl font-bold leading-relaxed mb-6 mt-8">
                Conclusion: The Future Belongs to the Fast
              </h2>

              <p className="w-full text-base leading-relaxed mb-4">
                In today's business landscape, speed isn't just efficiency —
                it's strategy. The ability to communicate ideas faster than
                competitors can mean the difference between closing a deal and
                missing an opportunity.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                <span className="font-bold">Zynth.ai</span> brings that
                advantage to your fingertips — combining AI, automation, and
                design intelligence to save hours every week while delivering
                professional, brand-consistent decks.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                Whether you're an executive, a marketer, or a consultant, Zynth
                lets you focus on ideas — while AI handles the rest.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                The future of presentations isn't just beautiful — it's instant.
              </p>

              <p className="w-full text-base leading-relaxed mb-4">
                So next time you're about to start a PowerPoint from scratch,
                remember: With <span className="font-bold">Zynth Platform</span>
                , <span className="font-bold">Zynth Extension</span>, and{" "}
                <span className="font-bold">Zynth API</span>, your deck could
                already be done.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Blog36;
